













































import { Component, Vue } from 'vue-property-decorator';
import play from '@/resources/directives/play';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import FooterButton from '@/components/FooterButton.vue';

@Component({
  components: {
    CameraPageHeader,
    FooterButton
  },
  directives: {
    play
  }
})
export default class Page extends Vue {
  private scrollerHeight: number = 0;
  private dynamicAreaHeight: number = 0;

  public get photoHeight(): number {
    const displayWidth: number = this.$store.state.camera.displayWidth;
    const displayHeight: number = this.$store.state.camera.displayHeight;
    if (displayWidth <= 0 || displayHeight <= 0) return 0;
    // 画面高さから取りうる画像高さ
    const pageHeaderHeight: number = this.$store.state.camera.headerHeight;
    const totalHeight: number = pageHeaderHeight + this.dynamicAreaHeight;
    const maxPhotoHeight: number = displayHeight - totalHeight;
    // 画面幅から計算する画像高さ
    const photoAspectRatio: number = 4 / 3;
    const photoMarginHorizontal: number = 20;
    const basePhotoWidth: number = Math.min(displayWidth - photoMarginHorizontal * 2, 500);
    const basePhotoHeight: number = basePhotoWidth / photoAspectRatio;
    // 画像高さを計算する
    const photoHeight: number = Math.min(basePhotoHeight, maxPhotoHeight);
    const minPhotoHeight: number = 100;
    return Math.max(photoHeight, minPhotoHeight);
  }

  private get isScroll(): boolean {
    return this.scrollerHeight > this.$store.state.camera.displayHeight;
  }

  public async created(): Promise<void> {
    // ページマウント時の設定
    await this.$store.dispatch('camera/mountedSetting', this.$route.path);
  }

  public mounted(): void {
    this.calcDynamicAreaHeight();
  }

  public updated(): void {
    this.calcDynamicAreaHeight();
  }

  private calcDynamicAreaHeight(): void {
    if (!this.$el) return;
    const scroller: HTMLDivElement = this.$el.getElementsByClassName('page-scroller').item(0) as HTMLDivElement;
    const contentHeader: HTMLDivElement = this.$el.getElementsByClassName('page-contents-title-container').item(0) as HTMLDivElement; // eslint-disable-line prettier/prettier
    const contentFooter: HTMLDivElement = this.$el.getElementsByClassName('page-contents-description').item(0) as HTMLDivElement; // eslint-disable-line prettier/prettier
    const pageFooter: HTMLDivElement = this.$el.getElementsByClassName('page-footer').item(0) as HTMLDivElement;
    const scrollerRect: DOMRect = scroller.getBoundingClientRect() as DOMRect;
    const contentHeaderRect: DOMRect = contentHeader.getBoundingClientRect() as DOMRect;
    const contentFooterRect: DOMRect = contentFooter.getBoundingClientRect() as DOMRect;
    const pageFooterRect: DOMRect = pageFooter.getBoundingClientRect() as DOMRect;
    this.scrollerHeight = scrollerRect.height;
    this.dynamicAreaHeight = contentHeaderRect.height + contentFooterRect.height + pageFooterRect.height;
  }

  private onStart(): void {
    this.$router.push(this.$store.getters['camera/locationShoot']);
  }
}
